import { FeeData } from '@exodus/asset-lib'
import assert from 'minimalistic-assert'

const createFeeDataConfigDefaults = ({ currency, feeDataConfig }) => {
  const shared = {
    tipGasPrice: '0 Gwei',
    fuelThreshold: '0 Gwei',
    gasPriceMinimumRate: 0.6,
    gasPriceMaximumRate: 1.3,
    gasPriceMultiplier: 1,
  }

  if (feeDataConfig.eip1559Enabled === true) {
    assert(feeDataConfig.baseFeePerGas, 'baseFeePerGas is required')
    const baseFeePerGas = currency.parse(feeDataConfig.baseFeePerGas)
    const gasPrice = feeDataConfig.gasPrice
      ? currency.parse(feeDataConfig.gasPrice)
      : baseFeePerGas.mul(1.5)
    return {
      gasPrice: gasPrice.toBaseString({ unit: true }),
      baseFeePerGas: baseFeePerGas.toBaseString({ unit: true }),
      eip1559Enabled: feeDataConfig.eip1559Enabled,
      ...shared,
      ...feeDataConfig,
    }
  }

  if (feeDataConfig.eip1559Enabled === false) {
    assert(feeDataConfig.gasPrice, 'gasPrice is required')
    const gasPrice = currency.parse(feeDataConfig.gasPrice)
    return {
      gasPrice: gasPrice.toBaseString({ unit: true }),
      max: gasPrice.mul(5).toBaseString({ unit: true }),
      min: gasPrice.div(5).toBaseString({ unit: true }),
      eip1559Enabled: feeDataConfig.eip1559Enabled,
      ...shared,
      ...feeDataConfig,
    }
  }

  return {
    gasPrice: '0.02 Gwei',
    baseFeePerGas: '0.02 Gwei',
    eip1559Enabled: true,
    ...shared,
    ...feeDataConfig,
  }
}

export const createFeeData = ({ currency, feeDataConfig }) => {
  return new FeeData({
    config: createFeeDataConfigDefaults({ currency, feeDataConfig }),
    mainKey: 'gasPrice',
    currency,
  })
}
